export function Maragogi() {
  return (
    <div className="flex justify-center items-center mt-12 px-4">
      <img className="h-10" src="/icons/water.svg" alt="Conheça Maragogi" />
      <h3 className="px-4 text-2xl text-indigo-900 md:text-3xl md:px-8">Conheça Maragogi</h3>
      <img className="h-10" src="/icons/water.svg" alt="Conheça Maragogi" />
    </div>
  )
}